"use strict";
const numeral = require('numeral');
if (!numeral.locales.sv) {
    numeral.register('locale', 'sv', {
        delimiters: {
            thousands: ' ',
            decimal: ',',
        },
        abbreviations: {
            thousand: 't',
            million: 'mn',
            billion: 'md',
            trillion: 'exa',
        },
        ordinal(number) {
            return number === 1 ? 'er' : 'ème';
        },
        currency: {
            symbol: 'kr',
        },
    });
}
numeral.locale('sv');
function simplifyWhenSwedishCurrency(currency) {
    return currency === 'SEK' ? 'kr' : currency;
}
module.exports = {
    shortForm: (number, currency) => `${numeral(number).format('0,0.0 a') || 0.0} ${simplifyWhenSwedishCurrency(currency || 'SEK')}`,
    longForm: (number, currency) => `${numeral(number).format('0,0.00') || 0.0} ${simplifyWhenSwedishCurrency(currency || 'SEK')}`,
};
